var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "add-function"
  }, [_c("a-form-model", {
    ref: "form",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 14
      },
      rules: _vm.ruleData
    }
  }, [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("函数名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("函数名称"),
      disabled: _vm.$route.params.type === "see",
      "max-length": 15,
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("函数标识"),
      prop: "mark"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("函数标识"),
      disabled: _vm.$route.params.type === "edit" || _vm.$route.params.type === "see",
      "max-length": 30,
      allowClear: ""
    },
    model: {
      value: _vm.form.mark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "mark", $$v);
      },
      expression: "form.mark"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("提示说明"),
      prop: "tipDescription"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("提示说明"),
      "max-length": 100,
      disabled: _vm.$route.params.type === "see",
      allowClear: ""
    },
    model: {
      value: _vm.form.tipDescription,
      callback: function ($$v) {
        _vm.$set(_vm.form, "tipDescription", $$v);
      },
      expression: "form.tipDescription"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("函数示例"),
      prop: "example"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("函数示例"),
      disabled: _vm.$route.params.type === "see",
      "max-length": 100,
      allowClear: ""
    },
    model: {
      value: _vm.form.example,
      callback: function ($$v) {
        _vm.$set(_vm.form, "example", $$v);
      },
      expression: "form.example"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("输入类型"),
      prop: "inputType"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择"),
      disabled: _vm.$route.params.type === "see",
      allowClear: "",
      mode: "multiple"
    },
    model: {
      value: _vm.form.inputType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "inputType", $$v);
      },
      expression: "form.inputType"
    }
  }, _vm._l(_vm.inputTypeOption, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(_vm._s(_vm.$t(item.label)))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("输入个数"),
      prop: "inputNumber"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      disabled: _vm.$route.params.type === "see",
      precision: 0,
      parser: value => value.replace(/[^\d]/g, ""),
      placeholder: _vm.$t("请输入") + _vm.$t("输入个数")
    },
    model: {
      value: _vm.form.inputNumber,
      callback: function ($$v) {
        _vm.$set(_vm.form, "inputNumber", $$v);
      },
      expression: "form.inputNumber"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("输入说明"),
      prop: "inputDescription"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("输入说明"),
      "max-length": 100,
      disabled: _vm.$route.params.type === "see",
      allowClear: ""
    },
    model: {
      value: _vm.form.inputDescription,
      callback: function ($$v) {
        _vm.$set(_vm.form, "inputDescription", $$v);
      },
      expression: "form.inputDescription"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("输出类型"),
      prop: "outputType"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("输出类型"),
      disabled: _vm.$route.params.type === "see",
      allowClear: ""
    },
    model: {
      value: _vm.form.outputType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "outputType", $$v);
      },
      expression: "form.outputType"
    }
  }, _vm._l(_vm.outputTypeOption, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(_vm._s(_vm.$t(item.label)))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("输出说明"),
      prop: "outputDescription"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("输出说明"),
      "max-length": 100,
      disabled: _vm.$route.params.type === "see",
      allowClear: ""
    },
    model: {
      value: _vm.form.outputDescription,
      callback: function ($$v) {
        _vm.$set(_vm.form, "outputDescription", $$v);
      },
      expression: "form.outputDescription"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备注"),
      prop: "remark"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("备注"),
      disabled: _vm.$route.params.type === "see",
      allowClear: ""
    },
    model: {
      value: _vm.form.remark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "remark", $$v);
      },
      expression: "form.remark"
    }
  })], 1)], 1)], 1), _c("a-col", {
    staticClass: "btnBox",
    attrs: {
      span: 24
    }
  }, [_vm.$route.params.type !== "see" ? _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "add",
      loading: _vm.loading
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))]) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };